import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import WhatsAppFloatButton from './components/whatsappFloat/WhatsAppFloatButton';
import AnalyticsTracker from './AnalyticsTracker';
import { captureLeadRef } from './utils/leadRef';

// Keep the chatbot ?ref= code (from WhatsApp / Instagram links) before the app reads the URL
captureLeadRef();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
            <WhatsAppFloatButton />
            <AnalyticsTracker />
            {/* <AiChatbot /> */}
        </BrowserRouter>
    </React.StrictMode>
);
